var _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 45,
    viewBox: "0 0 50 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.50317,
    width: 43.7812,
    height: 12.7591,
    rx: 6.37955,
    fill: "#11E372"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 16.0106,
    width: 29.2709,
    height: 12.7591,
    rx: 6.37955,
    fill: "#11E372"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 32.0224,
    width: 13.0093,
    height: 12.7591,
    rx: 6.37955,
    fill: "#11E372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMini);
export default __webpack_public_path__ + "static/media/logo-mini.95245706df2ade204a836e9076f189e3.svg";
export { ForwardRef as ReactComponent };